import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-agreement-support-services-form',
  templateUrl: './agreement-support-services-form.component.html',
  styleUrls: ['./agreement-support-services-form.component.scss'],
})
export class AgreementSupportServicesFormComponent {
  /** Set the agreement service description form control value with the agreedService input */
  @Input() set agreedService(service: string) {
    this.serviceDescription.setValue(service);
  }

  /** Show any errors on the service description control if the user has tried to submit the rates */
  @Input() set hasSubmitted(hasSubmitted: boolean) {
    if (hasSubmitted) {
      this.serviceDescription.markAsDirty();
      this.serviceDescription.updateValueAndValidity();
    }
  }

  /** The service description change event emitter */
  @Output() valueChange = new EventEmitter<string>();

  /** Form control for the service description */
  serviceDescription = new FormControl<string>('', [Validators.required]);

  /**
   * Emit the service description changes.
   */
  onServiceDescriptionChange(): void {
    this.valueChange.emit(this.serviceDescription.value);
  }
}
